export const INPUT_MASK = '+7 (999) 999-99-99';
